/**
 * 袋ごとの味・甘さ選択 UI
 *
 * フレーバーや甘さの追加・変更はここの定数を編集するだけで反映される。
 */
const BAG_FLAVORS = [
  { value: 'brown_sugar_kinako', label: '黒糖きなこ' },
  { value: 'rich_chocolate',     label: 'リッチショコラ' },
  { value: 'milk_tea',           label: 'ミルクティー' },
  { value: 'cafe_latte',         label: 'カフェラテ' },
  { value: 'matcha_latte',       label: '抹茶' },
  { value: 'hojicha_latte',      label: 'ほうじ茶' },
  { value: 'cassis_berry',       label: 'カシス&ベリー' },
];

const BAG_SWEETNESS = [
  { value: 'light',  label: 'さっぱり' },
  { value: 'normal', label: '普通' },
  { value: 'sweet',  label: '甘め' },
];

const BAG_MAX_COUNT = 5;
const BAG_DEFAULT_COUNT = 1;

if (!customElements.get('bag-flavor-selector')) {
  customElements.define(
    'bag-flavor-selector',
    class BagFlavorSelector extends HTMLElement {
      constructor() {
        super();
        this.bagCount = BAG_DEFAULT_COUNT;
        this.listEl = null;
        this.errorEl = null;
        this.quantitySelect = null;
      }

      connectedCallback() {
        this.render();
        this.interceptFormSubmit();
      }

      render() {
        this.innerHTML = '';

        // 袋数セレクター
        const qtySection = document.createElement('div');
        qtySection.className = 'bag-selector__quantity';

        const qtyLabel = document.createElement('label');
        qtyLabel.setAttribute('for', 'bag-count-select');
        qtyLabel.textContent = '袋数';
        qtySection.appendChild(qtyLabel);

        this.quantitySelect = document.createElement('select');
        this.quantitySelect.id = 'bag-count-select';
        for (let i = 1; i <= BAG_MAX_COUNT; i++) {
          const opt = document.createElement('option');
          opt.value = i;
          opt.textContent = `${i}袋`;
          if (i === BAG_DEFAULT_COUNT) opt.selected = true;
          this.quantitySelect.appendChild(opt);
        }
        this.quantitySelect.addEventListener('change', (e) => {
          e.stopPropagation();
          this.bagCount = parseInt(this.quantitySelect.value, 10);
          this.renderBagList();
        });
        qtySection.appendChild(this.quantitySelect);
        this.appendChild(qtySection);

        // 見出し
        const heading = document.createElement('div');
        heading.className = 'bag-selector__heading';
        heading.textContent = '袋ごとの味・甘さを選択';
        this.appendChild(heading);

        // 袋リスト
        this.listEl = document.createElement('div');
        this.listEl.className = 'bag-selector__list';
        this.appendChild(this.listEl);

        // エラー表示
        this.errorEl = document.createElement('div');
        this.errorEl.className = 'bag-selector__error';
        this.errorEl.textContent = 'すべての袋の味と甘さを選択してください';
        this.appendChild(this.errorEl);

        this.renderBagList();
      }

      renderBagList() {
        const prev = this.getSelections();
        this.listEl.innerHTML = '';

        for (let i = 0; i < this.bagCount; i++) {
          const item = document.createElement('div');
          item.className = 'bag-selector__item';

          const label = document.createElement('div');
          label.className = 'bag-selector__item-label';
          label.textContent = this.bagCount > 1 ? `袋 ${i + 1}` : '';
          item.appendChild(label);

          const fields = document.createElement('div');
          fields.className = 'bag-selector__fields';

          fields.appendChild(
            this.createSelect(`bag-flavor-${i}`, '味', BAG_FLAVORS, prev[i]?.flavor)
          );
          fields.appendChild(
            this.createSelect(`bag-sweetness-${i}`, '甘さ', BAG_SWEETNESS, prev[i]?.sweetness)
          );

          item.appendChild(fields);
          this.listEl.appendChild(item);
        }
      }

      createSelect(name, labelText, options, selectedValue) {
        const wrapper = document.createElement('div');
        wrapper.className = 'bag-selector__field';

        const label = document.createElement('label');
        label.setAttribute('for', name);
        label.textContent = labelText;
        wrapper.appendChild(label);

        const select = document.createElement('select');
        select.id = name;
        select.name = name;
        select.required = true;

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = `${labelText}を選択`;
        placeholder.disabled = true;
        placeholder.selected = !selectedValue;
        select.appendChild(placeholder);

        for (const opt of options) {
          const option = document.createElement('option');
          option.value = opt.value;
          option.textContent = opt.label;
          if (selectedValue === opt.value) option.selected = true;
          select.appendChild(option);
        }

        select.addEventListener('change', (e) => e.stopPropagation());

        wrapper.appendChild(select);
        return wrapper;
      }

      getSelections() {
        const selections = [];
        for (let i = 0; i < this.bagCount; i++) {
          const flavorEl = this.listEl?.querySelector(`#bag-flavor-${i}`);
          const sweetnessEl = this.listEl?.querySelector(`#bag-sweetness-${i}`);
          selections.push({
            flavor: flavorEl?.value || '',
            sweetness: sweetnessEl?.value || '',
          });
        }
        return selections;
      }

      validate() {
        const selections = this.getSelections();
        const valid = selections.every((s) => s.flavor && s.sweetness);
        this.errorEl.classList.toggle('is-visible', !valid);
        return valid ? selections : null;
      }

      interceptFormSubmit() {
        const productForm = this.closest('product-info')?.querySelector('product-form');
        if (!productForm) return;

        const form = productForm.querySelector('form');
        if (!form) return;

        form.addEventListener('submit', (evt) => {
          evt.preventDefault();
          evt.stopImmediatePropagation();

          const selections = this.validate();
          if (!selections) return;

          const variantId = productForm.variantIdInput?.value;
          if (!variantId) return;

          const form_ = productForm.querySelector('form');
          const sellingPlanInput = form_?.querySelector('input[name="selling_plan"]');
          const sellingPlan = sellingPlanInput?.value || null;

          this.submitBags(variantId, selections, productForm, sellingPlan);
        }, true);
      }

      async submitBags(variantId, selections, productForm, sellingPlan) {
        const submitButton = productForm.querySelector('[type="submit"]');
        const spinner = productForm.querySelector('.loading__spinner');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        submitButton?.setAttribute('aria-disabled', 'true');
        submitButton?.classList.add('loading');
        spinner?.classList.remove('hidden');

        try {
          const token = localStorage.getItem('token');
          const refId = localStorage.getItem('ref_id');

          // note（assessment token）と attributes（ref_id）を先に設定
          const updatePayload = {};
          if (token) updatePayload.note = token;
          if (refId) updatePayload.attributes = { ref_id: refId };
          if (Object.keys(updatePayload).length > 0) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(updatePayload),
            });
          }

          // 袋ごとの items を構築してカートに追加
          const items = selections.map((bag) => {
            const item = {
              id: parseInt(variantId, 10),
              quantity: 1,
              properties: {
                _flavor: bag.flavor,
                _sweetness: bag.sweetness,
              },
            };
            if (sellingPlan) {
              item.selling_plan = parseInt(sellingPlan, 10);
            }
            return item;
          });

          // sections を /cart/add.js に含めて、レスポンスに key と sections を返してもらう
          const addBody = { items };
          if (cart) {
            addBody.sections = cart.getSectionsToRender().map((s) => s.id);
            addBody.sections_url = window.location.pathname;
          }

          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(addBody),
          });

          const addData = await addResponse.json();

          if (addData.status) {
            productForm.handleErrorMessage(addData.description);
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // /cart/add.js に複数 items を送ると、レスポンスは { items: [...], sections: {...} }
          // renderContents は parsedState.key を参照するので、最後に追加されたアイテムの key を設定する
          const lastItem = addData.items ? addData.items[addData.items.length - 1] : addData;
          const renderData = {
            ...addData,
            key: addData.key || lastItem.key,
            id: addData.id || lastItem.id,
          };
          cart.setActiveElement(document.activeElement);
          cart.renderContents(renderData);

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
          });
        } catch (e) {
          console.error('カート追加エラー:', e);
        } finally {
          submitButton?.classList.remove('loading');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          submitButton?.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        }
      }
    }
  );
}
